import { render, staticRenderFns } from "./RulePopup.vue?vue&type=template&id=0e2d3c7d&scoped=true&"
import script from "./RulePopup.vue?vue&type=script&lang=js&"
export * from "./RulePopup.vue?vue&type=script&lang=js&"
import style0 from "./RulePopup.vue?vue&type=style&index=0&id=0e2d3c7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2d3c7d",
  null
  
)

export default component.exports